import React from 'react'
import {connect} from 'react-redux'

import Component from '../components/review'
// import depositActions from '../actions/deposit'
// import actions from '../actions/review'
// import moment from '../../../common/moment'

class Container extends React.Component {
  render() {
    return <Component {...this.props}/>
  }

  static propTypes = {}
}

const mapStateToProps = state => {
  // const data = state.ui.deposit.review
  // const startData = state.ui.deposit.start
  // const hour = startData.getIn(['transaction', 'Reserve']).TimeSlot.get('Hour')
  // const minute = startData.getIn(['transaction', 'Reserve']).TimeSlot.get('Minute')
  // const date = moment.utc(startData.getIn(['transaction', 'Reserve']).Date).hour(hour).minute(minute)
  // return {
  //   address: startData.getIn(['transaction', 'ID']) ? startData.getIn(['transaction', 'ClientAddress']).Address : "",
  //   date: date,
  //   card: startData.getIn(['transaction', 'ID']) && startData.getIn(['transaction', 'Card']).ID !== 0
  //     ? startData.getIn(['transaction', 'Card'])
  //     : null,
  //   comment: data.get('comment'),
  //   isSaving: data.get('isSaving'),
  //   isConfirming: data.get('isConfirming'),
  //   error: data.get('error'),
  // }
}

const mapDispatchToProps = dispatch => {
  return {
    // setStep: step => dispatch(depositActions.setStep(step)),
    // setComment: value => dispatch(actions.setComment(value)),
    // confirm: () => dispatch(actions.confirm()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/rent/containers/review.js